import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-132b5194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px" }
const _hoisted_2 = { class: "card card-one me-lg-5 mb-5 mb-lg-0" }
const _hoisted_3 = {
  class: "card-header px-5 py-4 position-sticky bg-white top-0 z-index-1",
  id: "kt_chat_contacts_header"
}
const _hoisted_4 = { class: "d-flex flex-stack" }
const _hoisted_5 = {
  class: "position-relative w-100",
  autocomplete: "off"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "d-none"
}, null, -1))
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-sync fs-1 text-primary" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  key: 0,
  class: "fw-bolder text-gray-900 text-hover-primary mb-2 pt-3",
  role: "button",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  "data-kt-menu-target": `#vz-filter-data-smsFilters`
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-filter fs-1" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "position-absolute top-5 start-90 translate-middle badge badge-circle badge-cyan"
}
const _hoisted_17 = {
  class: "card-body py-5 px-0",
  id: "kt_chat_contacts_body"
}
const _hoisted_18 = { class: "d-flex flex-stack p-5 pt-0" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = {
  key: 0,
  class: "form-check me-2"
}
const _hoisted_21 = { class: "ms-1" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Are you sure to delete selected chat group(s)?", -1))
const _hoisted_24 = { class: "d-flex flex-column align-items-end ms-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed d-none" }, null, -1))
const _hoisted_27 = {
  class: "border border-gray-300 mb-5 collapse shadow",
  id: "createGroup"
}
const _hoisted_28 = { class: "card card-body p-4" }
const _hoisted_29 = { class: "mb-2" }
const _hoisted_30 = { class: "form-label required" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "my-2" }
const _hoisted_34 = { class: "form-label required" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "modal-footer justify-content-between px-0 border-top-0 pb-0" }
const _hoisted_38 = {
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
  type: "submit"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed d-none" }, null, -1))
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "d-flex align-items-center w-100" }
const _hoisted_42 = { class: "form-check me-2" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "ms-5 w-100" }
const _hoisted_45 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_46 = { class: "fw-bolder text-gray-900 text-hover-primary mb-2 mr-1" }
const _hoisted_47 = { class: "text-muted fs-8 mb-1" }
const _hoisted_48 = ["title"]
const _hoisted_49 = { class: "d-flex flex-row truncate" }
const _hoisted_50 = { class: "d-flex justify-content-between px-5 pt-3 card-footer position-sticky bg-white bottom-0" }
const _hoisted_51 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZFilter = _resolveComponent("VZFilter")!
  const _component_VZModal = _resolveComponent("VZModal")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_VZMultiSelect = _resolveComponent("VZMultiSelect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_UnReadBadge = _resolveComponent("UnReadBadge")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", _hoisted_5, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.searchChange && _ctx.searchChange(...args))),
              class: "svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-3 translate-middle-y"
            }, _hoisted_7),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control ps-13 mb-2 mb-sm-0",
              name: "search",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchSms) = $event)),
              onKeyup: _cache[2] || (_cache[2] = 
                () => {
                  if (_ctx.searchSms.length == 0 || _ctx.searchSms.length >= 3)
                    _ctx.searchChange();
                }
              ),
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_8), [
              [_vModelText, _ctx.searchSms]
            ]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.refreshList && _ctx.refreshList(...args)), ["stop"])),
              type: "button",
              class: "btn bg-transparent position-relative d-block pe-0"
            }, _hoisted_12)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _createVNode(_component_VZFilter, {
              options: _ctx.tableFilter,
              defaultFilter: {},
              viewName: "smsFilters",
              onFilterChange: _ctx.onFilterChange
            }, {
              actions: _withCtx(() => [
                (_ctx.tableFilter && _ctx.tableFilter.length)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_14, [
                      _hoisted_15,
                      (_ctx.activeFilter)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.activeFilter), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["options", "onFilterChange"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (
                  _ctx.hasPermission('VYZOR:APPLICATIONS:SMS:DELETE') &&
                  _ctx.smsData.length > 0
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "inboxCheckAll",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkAll) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.checkAll]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                (_ctx.hasPermission('VYZOR:APPLICATIONS:SMS:DELETE'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      disabled: _ctx.selectedForDelete.length < 1,
                      type: "button",
                      class: _normalizeClass(["btn btn-outline me-5 btn-outline-danger btn-active-light-danger", {
                    'btn-outline-danger btn-active-light-danger':
                      _ctx.selectedForDelete.length > 0,
                  }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDialog = true))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-trash-alt", {
                      'btn-outline-danger': _ctx.selectedForDelete.length > 0,
                    }])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.delete")), 1)
                    ], 10, _hoisted_22))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_VZModal, {
              id: `vz_modal_bulk_delete_email`,
              title: `${_ctx.t('common.confirmDelete')}`,
              widthClass: 'width-650',
              showDialog: _ctx.showDialog,
              onModalClose: _cache[8] || (_cache[8] = 
                () => {
                  _ctx.showDialog = false;
                }
              )
            }, {
              actions: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDialog = false))
                }, _toDisplayString(_ctx.t("common.close")), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline btn-outline-danger btn-active-light-danger min-w-90px",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onBulkDelete && _ctx.onBulkDelete(...args)))
                }, _toDisplayString(_ctx.t("common.delete")), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }, 8, ["title", "showDialog"]),
            _createElementVNode("div", _hoisted_24, [
              (_ctx.hasPermission('VYZOR:APPLICATIONS:SMS:CREATE'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#createGroup",
                    "aria-expanded": "false",
                    "aria-controls": "createGroup",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.createConversationForm?.resetForm()))
                  }, [
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("pages.sms.createGroup.title")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_Form, {
              "validation-schema": _ctx.conversationValidation,
              onSubmit: _ctx.createConversation,
              ref: "createConversationForm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("common.name")), 1),
                    _createVNode(_component_Field, {
                      class: "form-control",
                      modelValue: _ctx.title,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.title) = $event)),
                      type: "text",
                      name: "title",
                      autocomplete: "off",
                      id: "title"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_ErrorMessage, { name: "title" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("pages.sms.createGroup.participants")), 1),
                    (_ctx.options && _ctx.options.length > 0)
                      ? (_openBlock(), _createBlock(_component_Field, {
                          key: 0,
                          name: "selectedUser",
                          modelValue: _ctx.selectedUser,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedUser) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_VZMultiSelect, _mergeProps(field, {
                              modelValue: _ctx.selectedUser,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedUser) = $event)),
                              element: {
                        options: _ctx.options,
                        multiSelect: true,
                        placeholder: _ctx.t('pages.user.selectUser'),
                      }
                            }), null, 16, ["modelValue", "element"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_ErrorMessage, { name: "selectedUser" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("button", {
                      class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#createGroup",
                      "aria-expanded": "false",
                      "aria-controls": "createGroup",
                      type: "button",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args)))
                    }, _toDisplayString(_ctx.t("common.close")), 1),
                    _createElementVNode("button", _hoisted_38, _toDisplayString(_ctx.t("common.save")), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["validation-schema", "onSubmit"])
          ]),
          _hoisted_39,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smsData, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item,
              class: _normalizeClass(["d-flex flex-stack p-5 hoverClass", {
                'bg-normal': `${item.webId}` !== `${_ctx.conversationId}`,
                'bg-selected': `${item.webId}` === `${_ctx.conversationId}`,
              }]),
              onClick: _withModifiers(($event: any) => (_ctx.getSmsDetails(item, $event)), ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  (_ctx.hasPermission('VYZOR:APPLICATIONS:SMS:DELETE'))
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "checkbox",
                        class: "form-check-input",
                        value: item.webId,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedForDelete) = $event)),
                        onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (
                      _ctx.selectedForDeleteClass =
                        _ctx.selectedForDelete.length > 0 ? 'danger' : 'primary'
                    ), ["stop"]))
                      }, null, 8, _hoisted_43)), [
                        [_vModelCheckbox, _ctx.selectedForDelete]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("a", _hoisted_46, _toDisplayString(item.title && item.title.length > 18
                          ? item.title.substring(0, 18) + "..."
                          : item.title), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.format.DateAndTime(item.createdDate)), 1),
                      _createVNode(_component_UnReadBadge, { item: item }, null, 8, ["item"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      class: "d-inline-flex flex-row fw-bold text-gray-400",
                      "data-bs-toggle": "tooltip",
                      "data-bs-placement": "top",
                      title: _ctx.getParticipants(item.participants)
                    }, [
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.getParticipants(item.participants) &&
                          _ctx.getParticipants(item.participants).length > 20
                            ? _ctx.getParticipants(item.participants).substring(
                                0,
                                20
                              ) + "..."
                            : _ctx.getParticipants(item.participants)), 1)
                    ], 8, _hoisted_48)
                  ])
                ])
              ])
            ], 10, _hoisted_40))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", null, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("select", {
                name: "kt_customers_table_length",
                class: "form-select form-select-sm",
                onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args))),
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.rowsPerPage) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PAGE_ITEM, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item,
                    value: item
                  }, _toDisplayString(item), 9, _hoisted_51))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.rowsPerPage]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_pagination, {
              "current-page": _ctx.page,
              "onUpdate:current-page": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.page) = $event)),
              onCurrentChange: _ctx.currentPageChange,
              "page-size": +_ctx.rowsPerPage || 0,
              layout: "prev, pager, next",
              total: _ctx.total,
              "hide-on-single-page": false,
              background: ""
            }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
          ])
        ])
      ])
    ])
  ]))
}